import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { SearchField } from '@lifeomic/chroma-react/components/SearchField';

export const useStyles = makeStyles(() => ({
  search: {
    width: '60%',
  },
  div: {
    width: '100%',
  },
}));

const messages = defineMessages({
  auditLogSearchLabel: {
    id: 'pages.auditLog.searchLabel',
    defaultMessage:
      'Type your search using query string syntax: (create or update) AND *@lifeomic.com',
  },
  auditTrailSearch: {
    id: 'pages.auditLog.auditTrailSearch',
    defaultMessage: 'Audit trail search',
  },
});

interface AuditSearchFieldProps {
  setSearchValue: (searchValue: string) => void;
}

const AuditSearchField: React.FC<AuditSearchFieldProps> = ({
  setSearchValue,
}) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      onKeyPress={e => {
        e.key === 'Enter' && e.preventDefault();
      }}
      className={classes.div}
      onClick={e => {
        e.preventDefault();
      }}
    >
      <SearchField
        aria-label={formatMessage(messages.auditTrailSearch)}
        className={classes.search}
        fullWidth
        placeholder={formatMessage(messages.auditLogSearchLabel)}
        onSearch={setSearchValue}
        onClear={() => setSearchValue('*')}
        disableClearOnSearch
      />
    </div>
  );
};

export default React.memo(AuditSearchField);
